import {
    GetCustomerSupportRequestsResponse,
    IBxpWebStargateClient
} from "@/libraries/bxp-web-stargate-client/src";

// Helper function to fetch a single page
export const getCustomerSupportRequestsQuery = async ({
    stargateClient,
    page,
    size
}: {
    stargateClient: IBxpWebStargateClient;
    page: number;
    size: number;
}) => {
    const offset = (page - 1) * size;

    const query = `
        query GetCustomerSupportRequests(
            $size: Int!
            $offset: Int!
        ) {
            customerSupport {
                me {
                    requests(project: "MOVE", size: $size, offset: $offset) {
                        total
                        page {
                            summary
                            description
                            status {
                                category
                                text
                            }
                            id
                            atlassianCloudUrl
                            planToMigrate
                            destinationLicense
                            sourceLicense
                            migrationProducts
                            migrationPhase
                        }
                    }
                }
            }
        }
    `;

    return await stargateClient.getCspGraphqlRequest<GetCustomerSupportRequestsResponse>(
        {
            request: JSON.stringify({
                query: query,
                variables: { size, offset }
            })
        }
    );
};
